module.exports = __webpack_public_path__ + "media/images/icons/flags/BN-46de9a44c8cf5f603793bd66c5eb38f3.svg";